import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Container,
  Button,
  FormGroup,
  Label,
  Input,
  Col,
  Row,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  PaginationItem,
  PaginationLink,
  Pagination,
} from "reactstrap";
import { FileSaver } from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserPen, faCaretUp, faCaretDown } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { toast } from "react-toastify";
import * as pdfjsLib from "pdfjs-dist/webpack";
import BaseUrl from "../../base-api";
import "./VerificationCandidate.css";
import { Link, useNavigate } from "react-router-dom";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Buffer } from 'buffer';
import { blue } from "excel4node/distribution/lib/types/excelColor";

// Configure the workerSrc property
pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export default function VerificationCandidate() {
  const [allData, setAllData] = useState({});
  const [employeeData, setEmployeeData] = useState([]);
  const [twelthData, setTwelthData] = useState([]);
  const [document1, setDocument1] = useState();
  const [modal, setModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPage2, setCurrentPage2] = useState(1);
  const itemsPerPage = 5;
  const canvasRef = useRef(null);
  const [formData, setFormData] = useState({
    approval: "",
    remarks: "",
  });
  const toggle = () => setModal(!modal);
  const [array, setArray] = useState({
    applicantName: "",
    applicationStatus: "",
    course: "",
  });
  const navigate = useNavigate();
  const [pdfBlob, setPdfBlob] = useState(null);
  const [approveStatus, setApproveStatus] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortBy2, setSortBy2] = useState("");
  const [sortOrder2, setSortOrder2] = useState("asc");
  const [imageBlob, setImageBlob] = useState(null);

  const handleCardClick = (status) => {
    navigate('/SideBar/ViewRegistrationDetails', { state: { status } });
  };

  const imgRef = useRef(null);
  const fetchData = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/admin/allApplications`, {
        headers: { Authorization: localStorage.getItem("$3ingT0k3n") },
      });
      setAllData(response.data.applications);
      setEmployeeData(response.data.applications.filter(m => m.employee));
      setTwelthData(response.data.applications.filter(m => !m.employee));

    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const saveApplicationStatus = async () => {
    try {
      const response = await axios.post(
        `${BaseUrl}/admin/saveApplicationStatus`,
        { approveStatus, ...array, ...formData },
        {
          headers: { Authorization: localStorage.getItem("$3ingT0k3n") },
        }
      );
      if (response.status === 200) {
        toast.success("Application status saved successfully");
        fetchData();
        setModal(false);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    if (imageBlob && imgRef.current) {
      const renderImage = async () => {
        try {
          const url = URL.createObjectURL(imageBlob);
          imgRef.current.src = url;
        } catch (error) {
          toast.error('Error rendering image');
          console.error(error);
        }
      };
      renderImage();
    }
  }, [imageBlob]);

  const loadProfile = async (mob, doc) => {
    try {
      const formData = { mobileNumber: mob, docName: doc };
      const response = await axios.post(
        `${BaseUrl}/admin/viewDocument`,
        formData,
        {
          headers: { Authorization: localStorage.getItem('$3ingT0k3n') },
          responseType: 'arraybuffer',
        }
      );
      let contentType = response.headers['content-type'];
      if (!contentType) {
        // Fallback to checking the image data
        const uint = new Uint8Array(response.data);
        contentType = getImageType(uint);
      }

      // Create Blob based on image type
      const imageBlob = new Blob([response.data], { type: contentType });
      setImageBlob(imageBlob); // Setting Blob to state

      const applicantData = allData.find((c) => c.mobileNumber === mob);
      if (applicantData) {
        setArray({
          applicantName: applicantData.applicantName,
          applicationStatus: applicantData.applicationStatus,
          course: applicantData.course,
          mobileNumber: mob,
        });
      }
    } catch (error) {
      toast.error(error.message);
      console.error(error);
    }
  };

  const getImageType = (uint) => {
    const header = uint[0].toString(16) + uint[1].toString(16);
    switch (header) {
      case '8950': // PNG header
        return 'image/png';
      case 'ffd8': // JPEG header
        return 'image/jpeg';
      default:
        throw new Error('Unsupported image type');
    }
  };

  const modalOpen = () => {
    document.getElementById("reject").style.display = "block";
  };

  const modalClose = () => {
    document.getElementById("reject").style.display = "none";
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageChange2 = (page) => {
    setCurrentPage2(page);
  };

  const paginatedData = useMemo(
    () =>
      twelthData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      ),
    [twelthData, currentPage, itemsPerPage]
  );

  const totalPages = useMemo(
    () => Math.ceil(twelthData.length / itemsPerPage),
    [twelthData.length, itemsPerPage]
  );

  const toggleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };

  const getMimeTypeFromByteArray = (buffer) => {
    // Read the first few bytes of the file to determine the MIME type
    const arr = new Uint8Array(buffer).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16);
    }

    // Use the header to determine the MIME type
    switch (header) {
      case "89504e47":
        return "image/png";
      case "ffd8ffe0":
      case "ffd8ffe1":
      case "ffd8ffe2":
      case "ffd8ffe3":
      case "ffd8ffe8":
        return "image/jpeg";
      default:
        return "application/octet-stream"; // Fallback for unknown types
    }
  };

  const exportTwelth = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Registered Candidates');

    // Define worksheet columns
    worksheet.columns = [
      { header: 'Candidate Name', key: 'candidateName' },
      { header: 'Father Name', key: 'fatherName' },
      { header: 'Address', key: 'address' },
      { header: 'Course', key: 'course' },
      { header: 'Enrolled Date', key: 'enrolled' },
      { header: 'Fee Paid', key: 'feePaid' },
      { header: 'Photograph', key: 'photo' },
      { header: 'Signature', key: 'sign' },
      { header: '12th Document', key: '12th' },
      { header: 'University Document (if any)', key: 'uni' },
    ];

    // Loop through each data entry
    for (const t of twelthData) {
      // Add a row with data
      const row = worksheet.addRow({
        candidateName: t.applicantName,
        fatherName: t.fatherName,
        address: t.address,
        course: t.course,
        enrolled: t.enrolledOn,
        feePaid: t.status === 'COURSE_FEE_PAID' ? 'Yes' : 'No'
      });

      // Starting column index for images
      let nextImageCol = 6;
      // Loop through each document and add images
      for (const [docIndex, doc] of t.documents.entries()) {
        try {
          // Convert base64 string to buffer
          const imageBuffer = Buffer.from(doc.data, 'base64');

          // Determine the image extension
          const mimeType = getMimeTypeFromByteArray(imageBuffer);
          const extension = mimeType === 'image/jpeg' ? 'jpeg' : 'png';

          // Add image to the workbook
          const imageId = workbook.addImage({
            buffer: imageBuffer,
            extension: extension,
          });

          // Add the image to the specific cell
          worksheet.addImage(imageId, {
            tl: { col: nextImageCol, row: row.number - 1 }, // Top-left corner of the cell
            ext: { width: 100, height: 100 } // Dimensions of the image
          });

          // Move to the next column for the next image
          nextImageCol++;
        } catch (error) {
          console.error("Error adding image:", error);
        }
      }
    }

    // Write the workbook to buffer and save
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, '12th-Candidates.xlsx');
    } catch (error) {
      console.error("Error writing Excel file:", error);
    }
  };

  const exportUniv = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Registered Candidates');

    // Define worksheet columns
    worksheet.columns = [
      { header: 'Candidate Name', key: 'candidateName' },
      { header: 'Father Name', key: 'fatherName' },
      { header: 'Address', key: 'address' },
      { header: 'Course', key: 'course' },
      { header: 'Enrolled Date', key: 'enrolled' },
      { header: 'Fee Paid', key: 'feePaid' },
      { header: 'Photograph', key: 'photo' },
      { header: 'Signature', key: 'sign' },
      { header: '12th Document', key: '12th' },
      { header: 'University Document (if any)', key: 'uni' },
    ];

    // Loop through each data entry
    for (const t of employeeData) {
      // Add a row with data
      const row = worksheet.addRow({
        candidateName: t.applicantName,
        fatherName: t.fatherName,
        address: t.address,
        course: t.course,
        enrolled: t.enrolledOn,
        feePaid: t.status === 'COURSE_FEE_PAID' ? 'Yes' : 'No'
      });

      // Starting column index for images
      let nextImageCol = 6;
      // Loop through each document and add images
      for (const [docIndex, doc] of t.documents.entries()) {
        try {
          // Convert base64 string to buffer
          const imageBuffer = Buffer.from(doc.data, 'base64');

          // Determine the image extension
          const mimeType = getMimeTypeFromByteArray(imageBuffer);
          const extension = mimeType === 'image/jpeg' ? 'jpeg' : 'png';

          // Add image to the workbook
          const imageId = workbook.addImage({
            buffer: imageBuffer,
            extension: extension,
          });

          // Add the image to the specific cell
          worksheet.addImage(imageId, {
            tl: { col: nextImageCol, row: row.number - 1 }, // Top-left corner of the cell
            ext: { width: 100, height: 100 } // Dimensions of the image
          });

          // Move to the next column for the next image
          nextImageCol++;
        } catch (error) {
          console.error("Error adding image:", error);
        }
      }
    }

    // Write the workbook to buffer and save
    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'University-Candidates.xlsx');
    } catch (error) {
      console.error("Error writing Excel file:", error);
    }
  };

  const sortedData = useMemo(() => {
    let sorted = [...paginatedData];
    if (sortBy) {
      sorted = sorted.sort((a, b) => {
        const comparison = a[sortBy].localeCompare(b[sortBy]);
        return sortOrder === "asc" ? comparison : -comparison;
      });
    }
    return sorted;
  }, [paginatedData, sortBy, sortOrder]);

  const paginatedData2 = useMemo(
    () =>
      employeeData.slice(
        (currentPage2 - 1) * itemsPerPage,
        currentPage2 * itemsPerPage
      ),
    [employeeData, currentPage2, itemsPerPage]
  );

  const totalPages2 = useMemo(
    () => Math.ceil(employeeData.length / itemsPerPage),
    [employeeData.length, itemsPerPage]
  );

  const toggleSort2 = (column) => {
    if (sortBy2 === column) {
      setSortOrder2(sortOrder2 === "asc" ? "desc" : "asc");
    } else {
      setSortBy2(column);
      setSortOrder2("asc");
    }
  };

  const sortedData2 = useMemo(() => {
    let sorted = [...paginatedData2];
    if (sortBy2) {
      sorted = sorted.sort((a, b) => {
        const comparison = a[sortBy2].localeCompare(b[sortBy2]);
        return sortOrder2 === "asc" ? comparison : -comparison;
      });
    }
    return sorted;
  }, [paginatedData2, sortBy2, sortOrder2]);

  return (
    <div>
      <Container
        className="py-3 border round"
        style={{
          boxShadow:
            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          borderRadius: "9px",
        }}
      >
        <h5 className="text-center">
          Dear Admin, click on the icon given in 'Action' column to view and to
          approve/reject the uploaded documents.
        </h5>

        <form
          className="p-3 border round"
          style={{
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "9px",
          }}
        >
          <h5 className="text-left" style={{ color: "#000000" }}>
            Documents for Non-University Employee/ Ward/ Spouse
            {/* <a href="" onClick={(e) => {
              e.preventDefault(); exportTwelth();
            }} style={{
              float: 'right',
            }}>Export</a> */}
          </h5>

          <Table striped className=" text-center">
            <thead>
              <tr className="table-danger ">
                <th width="8%">Sr. no.</th>
                <th width="20%" onClick={() => toggleSort("applicantName")} style={{ cursor: "pointer" }}>
                  Name{" "}
                  {sortBy === "applicantName" && (
                    <FontAwesomeIcon icon={sortOrder === "asc" ? faCaretUp : faCaretDown} />
                  )}
                </th>
                <th width="40%" onClick={() => toggleSort("course")} style={{ cursor: "pointer" }}>
                  Applied Course{" "}
                  {sortBy === "course" && (
                    <FontAwesomeIcon icon={sortOrder === "asc" ? faCaretUp : faCaretDown} />
                  )}
                </th>
                <th width="20%">Document Status</th>
                <th width="12%">Action</th>
              </tr>
            </thead>
            <tbody>
              {sortedData
                .map((c, index) => (
                  <tr key={index}>
                    <th scope="row">
                      {(currentPage - 1) * itemsPerPage + index + 1}
                    </th>
                    <td>{c.applicantName}</td>
                    <td>{c.course}</td>
                    <td>{c.applicationStatus}</td>

                    <td>
                      {c.applicationStatus == "Pending" && (

                        <a

                          onClick={() => handleCardClick(c.mobileNumber)}

                          style={{ textDecoration: "underline", cursor: "pointer" }}
                        >
                          <FontAwesomeIcon icon={faUserPen} />
                        </a>

                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
          <Pagination className="mt-1" style={{ justifyContent: "center" }}>
            <PaginationItem disabled={currentPage <= 1}>
              <PaginationLink first href="" onClick={(e) => { e.preventDefault(); handlePageChange(1) }} />
            </PaginationItem>
            <PaginationItem disabled={currentPage <= 1}>
              <PaginationLink
                previous
                href=""
                onClick={(e) => { e.preventDefault(); handlePageChange(currentPage - 1) }}
              />
            </PaginationItem>
            {[...Array(totalPages)].map((_, i) => (
              <PaginationItem active={i + 1 === currentPage} key={i}>
                <PaginationLink
                  href=""
                  onClick={(e) => { e.preventDefault(); handlePageChange(i + 1) }}
                >
                  {i + 1}
                </PaginationLink>
              </PaginationItem>
            ))}
            <PaginationItem disabled={currentPage >= totalPages}>
              <PaginationLink
                next
                href=""
                onClick={(e) => { e.preventDefault(); handlePageChange(currentPage + 1) }}
              />
            </PaginationItem>
            <PaginationItem disabled={currentPage >= totalPages}>
              <PaginationLink
                last
                href=""
                onClick={(e) => { e.preventDefault(); handlePageChange(totalPages) }}
              />
            </PaginationItem>
          </Pagination>
        </form>

        <br />

        <form
          className="p-3 border round"
          style={{
            boxShadow:
              "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "9px",
          }}
        >
          <h5 className="text-left" style={{ color: "#000000" }}>
            Documents for University Employee/ Ward/ Spouse
            {/* <a href="" onClick={(e) => {
              e.preventDefault(); exportUniv();
            }} style={{
              float: 'right',
            }}>Export</a> */}
          </h5>

          <Table striped className=" text-center">
            <thead>
              <tr className="table-warning">
                <th width="8%">Sr. no.</th>
                <th width="20%" onClick={() => toggleSort2("applicantName")} style={{ cursor: "pointer" }}>
                  Name{" "}
                  {sortBy === "applicantName" && (
                    <FontAwesomeIcon icon={sortOrder === "asc" ? faCaretUp : faCaretDown} />
                  )}
                </th>
                <th width="40%" onClick={() => toggleSort2("course")} style={{ cursor: "pointer" }}>
                  Applied Course{" "}
                  {sortBy === "course" && (
                    <FontAwesomeIcon icon={sortOrder === "asc" ? faCaretUp : faCaretDown} />
                  )}
                </th>
                <th width="20%">Document Status</th>
                <th width="12%">Action</th>
              </tr>
            </thead>
            <tbody>
              {sortedData2
                .map((c, index) => (
                  <tr key={index}>
                    <th scope="row">
                      {(currentPage2 - 1) * itemsPerPage + index + 1}
                    </th>
                    <td>{c.applicantName}</td>
                    <td>{c.course}</td>
                    <td>{c.applicationStatus}</td>

                    <td>
                      {c.applicationStatus == "Pending" && (
                        <a

                          onClick={() => handleCardClick(c.mobileNumber)}

                          style={{ textDecoration: "underline", cursor: "pointer" }}
                        >
                          <FontAwesomeIcon icon={faUserPen} />
                        </a>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>

          <Pagination className="mt-1" style={{ justifyContent: "center" }}>
            <PaginationItem disabled={currentPage2 <= 1}>
              <PaginationLink first href="" onClick={(e) => { e.preventDefault(); handlePageChange2(1) }} />
            </PaginationItem>
            <PaginationItem disabled={currentPage2 <= 1}>
              <PaginationLink
                previous
                href=""
                onClick={(e) => { e.preventDefault(); handlePageChange2(currentPage2 - 1) }}
              />
            </PaginationItem>
            {[...Array(totalPages2)].map((_, i) => (
              <PaginationItem active={i + 1 === currentPage2} key={i}>
                <PaginationLink
                  href=""
                  onClick={(e) => { e.preventDefault(); handlePageChange2(i + 1) }}
                >
                  {i + 1}
                </PaginationLink>
              </PaginationItem>
            ))}
            <PaginationItem disabled={currentPage2 >= totalPages2}>
              <PaginationLink
                next
                href=""
                onClick={(e) => { e.preventDefault(); handlePageChange2(currentPage2 + 1) }}
              />
            </PaginationItem>
            <PaginationItem disabled={currentPage2 >= totalPages2}>
              <PaginationLink
                last
                href=""
                onClick={(e) => { e.preventDefault(); handlePageChange2(totalPages2) }}
              />
            </PaginationItem>
          </Pagination>
        </form>

        <Modal isOpen={modal} toggle={toggle} fullscreen id="Modal2">
          <ModalHeader toggle={toggle}>
            Verification of the Candidate Certificate
          </ModalHeader>
          <Row style={{ backgroundColor: "#e7e6e991" }}>
            <Col md={6}>
              <FormGroup className="m-2">
                <Label for="">Candidate Name</Label>
                <Input id="" name="" value={array.applicantName} type="text" disabled />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup className="m-2">
                <Label for=""> Course</Label>
                <Input id="" name="" value={array.course} type="text" disabled />
              </FormGroup>
            </Col>
          </Row>
          <ModalBody className="text-center">
            {imageBlob && (
              <img src={URL.createObjectURL(imageBlob)} alt="Fetched Image" />
            )}
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center" }}>
            <Row className="m-1">
              <h5 className="text-center">
                Kindly select the button given below to Approve/Reject the
                uploaded document
              </h5>
              <Col md={4}></Col>
              <Col md={4}>
                <FormGroup check>
                  <Input
                    name="radio1"
                    type="radio"
                    checked={approveStatus === "approve"}
                    onChange={() => {
                      setApproveStatus("approve");
                      setFormData({ ...formData, remarks: "" });
                      modalClose();
                    }}
                  />
                  <Label check>Approve</Label>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup check>
                  <Input
                    name="radio1"
                    type="radio"
                    checked={approveStatus === "reject"}
                    onChange={() => {
                      setApproveStatus("reject");
                      modalOpen();
                    }}
                  />
                  <Label check>Reject</Label>
                </FormGroup>
              </Col>
            </Row>
            <Input
              id="reject"
              type="textarea"
              style={{ display: "none" }}
              maxLength={"250"}
              placeholder="Enter your reason to reject the Document"
              rows={1}
              value={formData.remarks}
              onChange={(e) =>
                setFormData({ ...formData, remarks: e.target.value })
              }
            />
            <Button color="success" onClick={saveApplicationStatus}>
              {" "}
              Save{" "}
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </div>
  );
}
